export default "__VITE_ASSET__DDxaYyAW__"